const LOOKBOOK_FLIP_CAP = 50;
let lookbookFlipsSent = 0;
let lookbookViewSent = false;

function publishLookbook(name, payload) {
  const shopify =  (window).Shopify;
  let tries = 0;
  (function attempt() {
    try {
      if (shopify && shopify.designMode) return;
      const bus = shopify && shopify.analytics;
      if (bus && typeof bus.publish === 'function') { bus.publish(name, payload); return; }
      if (++tries < 20) setTimeout(attempt, 250);
    } catch (error) {
    }
  })();
}

class DivanoLookbook extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-lb-track]');
    this.viewport = this.querySelector('[data-lb-viewport]');
    this.pages = Array.from(this.querySelectorAll('[data-lb-page]'));
    this.index = 0;

    if (!this.track || this.pages.length === 0) return;

    this.querySelectorAll('[data-lb-prev]').forEach((btn) =>
      btn.addEventListener('click', () => this.go(this.index - 1, 'arrow')));
    this.querySelectorAll('[data-lb-next]').forEach((btn) =>
      btn.addEventListener('click', () => this.go(this.index + 1, 'arrow')));

    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { this.go(this.index - 1, 'key'); }
      else if (e.key === 'ArrowRight') { this.go(this.index + 1, 'key'); }
    });

    let startX = null, startY = null;
    this.viewport.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    this.viewport.addEventListener('touchend', (e) => {
      if (startX == null) return;
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
        this.go(this.index + (dx < 0 ? 1 : -1), 'swipe');
      }
      startX = startY = null;
    }, { passive: true });

    this.addEventListener('click', (e) => {
      const link = e.target instanceof Element ? e.target.closest('a[href]') : null;
      const page = link ? link.closest('[data-lb-page]') : null;
      const look = page ? this.pages.indexOf(page) + 1 : 0;
      if (look < 1) return;
      const range = page.getAttribute('data-lb-range') || '';
      publishLookbook('divano_lookbook_click', { look, range: /^[a-z0-9-]{1,64}$/.test(range) ? range : '' });
    });

    this.watchView();
    this.update();
  }

  disconnectedCallback() {
    if (this.viewObserver) this.viewObserver.disconnect();
  }

  watchView() {
    if (lookbookViewSent || !this.viewport || !('IntersectionObserver' in window)) return;
    const thresholds = [];
    for (let t = 0; t <= 20; t++) thresholds.push(t / 20);
    this.viewObserver = new IntersectionObserver((entries) => {
      const entry = entries[entries.length - 1];
      const screen = entry.rootBounds ? entry.rootBounds.height : window.innerHeight;
      if (entry.intersectionRatio < 0.5 && entry.intersectionRect.height < screen / 2) return;
      this.viewObserver.disconnect();
      if (lookbookViewSent) return;
      lookbookViewSent = true;
      publishLookbook('divano_lookbook_view', { look: this.index + 1, looks: this.pages.length });
    }, { threshold: thresholds });
    this.viewObserver.observe(this.viewport);
  }

  go(i, via) {
    const from = this.index;
    this.index = Math.max(0, Math.min(this.pages.length - 1, i));
    this.update();
    if (via && this.index !== from && lookbookFlipsSent < LOOKBOOK_FLIP_CAP) {
      lookbookFlipsSent++;
      publishLookbook('divano_lookbook_flip', { look: this.index + 1, from: from + 1, via });
    }
  }

  update() {
    this.track.style.transform = 'translateX(-' + (this.index * 100) + '%)';
    this.pages.forEach((page, i) => {
      const active = i === this.index;
      page.setAttribute('aria-hidden', active ? 'false' : 'true');
      page.querySelectorAll('a, button').forEach((el) => { el.tabIndex = active ? 0 : -1; });
    });
  }
}

if (!customElements.get('divano-lookbook')) {
  customElements.define('divano-lookbook', DivanoLookbook);
}
